window.cselect = {
  init: () => {
    window.cselect.addListeners();
  },

  addListeners: () => {
    let cselects = document.querySelectorAll('.cselect:not(.event_is_set)');
    if (cselects.length) {
      cselects.forEach((item) => {
        let selected = item.querySelector('.cselect__selected'),
            single_options = item.querySelectorAll('.cselect__option');
        selected.addEventListener('click', (item) => {
          window.cselect.toggleOptions(item.currentTarget.closest('.cselect'));
        });
        single_options.forEach((single_option, single_option_index) => {
          single_option.addEventListener('click', () => {
            let index = parseFloat(single_option.getAttribute('data-index')),
                next_element = item.nextElementSibling,
                selected_text_value = item.querySelector('.cselect__selected__text__value'),
                option_text_value = single_option.querySelector('.cselect__option__text__value');

            if (next_element && next_element.classList.contains('select')) {
              let select = next_element.querySelector('select'),
                  event = new Event('change', { bubbles: true }),
                  data_submit_on_change = item.getAttribute('data-submit-on-change');

              select.selectedIndex = index;
              select.dispatchEvent(event);
              selected_text_value.innerHTML = option_text_value.innerHTML;
              single_options.forEach((single_option) => {
                single_option.classList.remove('is_selected');
              });
              single_option.classList.add('is_selected');
              window.cselect.hideAllOptions();

              if (data_submit_on_change == 'true') {
                item.closest('form').submit();
              }
            } else {
              let data_name = item.getAttribute('data-cselect-name');
              
              if (data_name == 'shopify_product_variants') {
                let wrapper = item.closest('[data-swapper-wrapper]'),
                    radio_buttons = wrapper.querySelectorAll('.radio__button');
                    
                if (wrapper && radio_buttons.length) {
                  radio_buttons[single_option_index].querySelector('input').click();
                }
              }

              selected_text_value.innerHTML = option_text_value.innerHTML;
              single_options.forEach((single_option) => {
                single_option.classList.remove('is_selected');
              });
              single_option.classList.add('is_selected');
              window.cselect.hideAllOptions();
            }
          });
        })
        item.classList.add('event_is_set');
      });

      document.addEventListener('click', function(event) {
        let inside = false;
        cselects.forEach(div => {
          if (div.contains(event.target)) {
            inside = true;
          }
        });
        if (!inside) {
          cselects.forEach(div => {
            div.classList.remove('is_active');
          });
        }
      });
    }
  },

  toggleOptions: (item) => {
    if (item.classList.contains('is_active')) {
      window.cselect.hideOptions(item);
    } else {
      window.cselect.showOptions(item);
    }
  },

  showOptions: (item) => {
    item.classList.add('is_active');
  },

  hideOptions: (item) => {
    item.classList.remove('is_active');
  },

  hideAllOptions: () => {
    let cselects = document.querySelectorAll('.cselect');
    if (cselects.length) {
      cselects.forEach((item) => {
        item.classList.remove('is_active');
      });
    }
  }
};

window.cselect.init();
